import React, { useEffect, useState } from "react";
import QNASearch from "./QNASearch";
import QNAPagination from "./QNAPagination";
import "./QNAHome.scss";
import { Spinner } from "@bphxd/ds-core-react";
import OrderTable from "./QNATable";
import { questionnaireOrders } from "../../api/endpoints";
export default function QNAHome() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [srhField, setSrhField] = useState<string>("");
  const [selectedField, setSelectedField] = useState<string>("");

  const [tableData, setTableData] = useState<any[]>([]);
  const [noData, setNoData] = useState<string>("");
  const [searchValsState, setSearchValsState] = useState<string>("");

  const [currentPage, setCurrentPage] = useState<number>(0);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
 const token = sessionStorage.getItem("jwt");
  const [lastSearch, setLastSearch] = useState<{ field: string; val: string }>({
    field: "",
    val: "",
  });
  useEffect(() => {
    // prevent initial empty API call
    if (!srhField || !searchValsState) return;
  
    const offset = currentPage * pageSize;
  
    onQNASearch(srhField, searchValsState, offset);
  }, [currentPage]); // trigger only on page change
  const onQNASearch = async (
    searchField: string,
    searchVal: string,
    offset = 0
  ) => {
    const mappedField = searchField;
  
    const isFieldChanged = mappedField !== lastSearch.field;
    const isNewSearch =
      mappedField !== lastSearch.field || searchVal !== lastSearch.val;
  
    // Reset pagination if new search
    if (isNewSearch) {
      setCurrentPage(0);
      setLastSearch({ field: mappedField, val: searchVal });
    }
  
    // Clear table immediately if field changed
    if (isFieldChanged) {
      setTableData([]);
      setTotalItems(0);
      setNoData("");
    }
  
    setSrhField(mappedField);
    setSearchValsState(searchVal);
    setIsLoading(true);
  
    // avoid flicker on pagination
    if (offset === 0 && !isFieldChanged) {
      setTableData([]);
    }
  
    try {
      const url = `${questionnaireOrders}?searchField=${mappedField}&searchVal=${searchVal}&offSet=${offset}`;
  
      const response = await fetch(url, {method: 'get',
        headers: {
          'Content-Type': 'application/json',
          AuthorizationToken: `Bearer ${token}`
        }});
      const resData = await response.json();
  
      //  Directly use resData
      if (!resData || !resData.data || resData.data.length === 0) {
        setNoData("No data found! Please check search/filter parameters");
        setTableData([]);
      } else {
        setSelectedField(mappedField);
        setTableData(resData.data);
  
        setTotalItems(resData.totalCount || 0);
        setPageSize(resData.pagination?.limit || 10);
  
        setCurrentPage(
          (resData.pagination?.offset || 0) /
            (resData.pagination?.limit || 10)
        );
      }
    } catch (error) {
      console.error("API Error:", error);
      setNoData("Error fetching data");
      setTableData([]);
    } finally {
      setIsLoading(false);
    }
  };          

  // Pagination handler
  const handlePageChange = (offset: number, pageIndex: number) => {
    setCurrentPage(pageIndex);
    onQNASearch(srhField, searchValsState, offset);
  };

  return (
    <div className="App bg-secondary">
      {/* Search */}
      <QNASearch
        onQNASearch={onQNASearch}
        setNoData={setNoData}
        setrawData={() => {}}
        setSelectedField={setSelectedField}
      />

      {/* Loader */}
      {isLoading && (
        <div className="table-loader">
          <Spinner color="brand" />
        </div>
      )}

      <div className="row">
        <div className="col-sm-9 col-lg-10 col-12 position-relative md-margin">
          
          {/* Table */}
          {tableData.length > 0 && !isLoading && (
            <>
              <OrderTable rowData={tableData} />

              {/* ✅ Pagination */}
              <QNAPagination
                totalCount={totalItems}
                pageSize={pageSize}
                onPageChange={handlePageChange}
              />
            </>
          )}

          {/*  No Data */}
          {noData && !isLoading && (
            <div
            style={{ height: "300px", width: "100%", textAlign: "center" }}
            className="no-Data-div"
          >
            {noData}
          </div>
          )}
        </div>
      </div>
    </div>
  );
}